import ActivateTabFunc from "./activateTabFunc";
import { ChangeTab } from "../../toplist/toplist";
import ActivateApptusTab from "./activateApptusTab";

export default function initSelectForTabs(callback) {
  $(".tab-frame").each(function (index, tabItem) {
    var holder = $(this);
    var tabsNavItem = holder.find(".tabs-nav > li");
    if (tabsNavItem.length == 0) {
      return;
    }

    var select = $('<select aria-label="tabPanel"></select>');
    var tabParent = holder.children('.tab-panel');

    tabsNavItem.each(function (key, item) {
      var selected = $(this).hasClass("active") ? "selected" : ""; 
      var id = $(item).find("a").attr("id") ? 'id=' + $(item).find("a").attr("id") : '';
      var value = '';
      if($(item).attr("data-tab-index")) {
        value += ' data-tab-index=' + $(item).attr("data-tab-index");
      }
      if($(item).attr("id")) {
        value += ' data-val=' + $(item).attr("id");
      }

      if($(item).children('[data-relativeid]').attr('data-relativeid')) {
        value += ' data-relativeid=' + $(item).children('[data-relativeid]').attr("data-relativeid");
      }

      var option = $('<option '+ id + selected + value + '  >' + $(item).text() + '</option>');

      option.appendTo(select);
    });

    tabParent.append(select);

    select.on("change", function () {
    var currentAttr = $(this).find(':selected');
    if (currentAttr.data("tab-index") >= 0) {
      ChangeTab(currentAttr);
      return;
    }
    if (currentAttr.data("val")) {
      ActivateApptusTab(currentAttr.data("val"), true);
    }
    else {
      if(currentAttr.data('relativeid')) {
        let id = currentAttr.data('relativeid');
        $(`.tabs-nav [data-relativeid="${id}"]`).trigger('click');
      } else {
        currentAttr[0].index === 2 ? ActivateTabFunc(currentAttr, callback) : ActivateTabFunc(currentAttr);
      }
    }
  });
  });
}